import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  FormGroup,
  FormField,
  Icon,
  Dropdown
} from 'semantic-ui-react'

const CardSelectRehabUX = (props: any) => {
    return(
      <div
        id="CardSelectPackageUX-div-0"
        style={{width: "100%"}}>
        <div
          id="CardSelectPackageUX-div-1"
          style={{border: "1px solid rgba(33, 133, 208, 1)", minHeight: "7.5rem", width: "100%", position: "relative", borderRadius: "5px", ...(props.isNotFound ?{display: "grid", placeContent:"center"}:{padding:"0.5rem 1.2rem"})}}>

          <Button
            color="blue"
            disabled={props.readOnly}
            id="CardSelectPackageUX-Button-3"
            onClick={props.onAddRehab}
            style={{position: "absolute", right: 12, top: 12, fontSize: "0.9rem", display: (props.isShowDetail && !props.isEditingAppointment) || !props.isLoadingSuccess? "none": ""}}>
            {props.languageUX === "en" ? "Select Treatment Plan" : "เลือกแผนการรักษา"}
          </Button>
          <div
            id="CardSelectPackageUX-div-4"
            style={{fontWeight: "bold", color: "#BDBDBD", fontSize: "1.3rem", display: props.isNotFound && props.isLoadingSuccess ? "":"none"}}>
            {props.languageUX === "en" ? "Please select the treatment plan for scheduling an appointment" : "กรุณาเลือกแผนการรักษาเพื่อทำการนัดหมาย"}
          </div>
          <div
            id="CardSelectPackageUX-div-5"
            style={{display: props.isNotFound || !props.isLoadingSuccess ? "none":"", margin: "0.5rem 0"}}>
            {props.rehabItems}
          </div>
        </div>
        <div
          id="CardSelectPackageUX-div-6"
          style={{padding: "1.25rem 0.5rem 2rem 1rem"}}>

          <div
            className="ui form"
            id="CardSelectPackageUX-div-7"
            style={{display: props.isShowDetail? "": "none"}}>

            <FormGroup
              id="CardSelectPackageUX-FormGroup-23"
              inline={true}
              style={{fontSize: "1.15rem", marginBottom: "0.5rem"}}>
              <FormField
                id="CardSelectPackageUX-FormField-24"
                inline={true}>
                <label
                  id="CardSelectPackageUX-label-25"
                  style={{color: "#0072BC"}}>
                  {props.languageUX === "en" ? "Appointment date & time" : "วันและเวลานัดหมาย"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectPackageUX-FormGroup-26"
              inline={true}>
              <FormField
                id="CardSelectRehabUX-FormField-50">
                <div
                  id="CardSelectRehabUX-div-51"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Date" : "วันที่"}
                </div>
              </FormField>
              <FormField
                id="CardSelectPackageUX-FormField-27"
                inline={true}>
                <label
                  id="CardSelectPackageUX-label-30"
                  style={{fontWeight: "normal", fontSize: "1rem"}}>
                  {props.slotDate || ""}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectRehabUX-FormGroup-62"
              style={{marginTop: "-0.5rem"}}>
              <FormField
                id="CardSelectRehabUX-FormField-63">
                <div
                  id="CardSelectRehabUX-div-64">
                  {props.deviceList}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectRehabUX-FormGroup-53"
              inline={true}>
              <FormField
                id="CardSelectRehabUX-FormField-54"
                inline={true}>
                <div
                  id="CardSelectRehabUX-div-60"
                  style={{color: "#0072BC", fontWeight: "bold"}}>
                  Physiotherapist
                </div>
              </FormField>
              <FormField
                id="CardSelectRehabUX-FormField-56">
                <label
                  id="CardSelectRehabUX-label-57"
                  style={{fontWeight: "normal"}}>
                  {props.physiotherapistName || "-"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectPackageUX-FormGroup-47"
              inline={true}
              style={{display: !props.isPostpone ? "none" : ""}}>
              <FormField
                id="CardSelectPackageUX-FormField-48"
                inline={true}
                width={16}>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectPackageUX-FormGroup-33"
              inline={true}
              style={{marginBottom: "0.5rem"}}>
              <FormField
                id="CardSelectPackageUX-FormField-34"
                inline={true}>
                <label
                  id="CardSelectPackageUX-label-36"
                  style={{fontSize: "1rem"}}>
                  {props.languageUX === "en" ? "Additional advice" : "คำแนะนำเพิ่มเติม"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectPackageUX-FormGroup-38"
              inline={true}>
              <FormField
                id="CardSelectPackageUX-FormField-39"
                inline={true}
                width={16}>
                <div
                  id="CardSelectRehabUX-div-52">
                  {props.orderNote||"-"}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSelectPackageUX-FormGroup-41"
              inline={true}
              style={{margin: "2.5rem 0 2rem"}}>
              <FormField
                id="CardSelectPackageUX-FormField-42"
                inline={true}
                style={{flex: 1}}>
              </FormField>
              <FormField
                id="CardSelectPackageUX-FormField-43"
                inline={true}
                style={{display: "flex", alignItems: "center"}}>
                <label
                  id="CardSelectRehabUX-label-66"
                  style={{display: props.isEditingAppointment?"none":"",marginRight: "0.5rem"}}>
                  {props.languageUX === "en" ? "language" : "ภาษา"}
                </label>
                <Dropdown
                  fluid={true}
                  id="CardSelectRehabUX-Dropdown-65"
                  onChange={props.onChangeLanguage}
                  options={props.languageOptions}
                  selection={true}
                  style={{display: props.isEditingAppointment?"none":"", width: "7rem",marginRight: "0.5rem"}}
                  value={props.language}>
                </Dropdown>
                <Button
                  color="yellow"
                  icon={true}
                  id="CardSelectPackageUX-Button-44"
                  onClick={props.onPrintBooking}
                  size="small"
                  style={{display: props.isEditingAppointment?"none":"",marginRight: "0.85rem"}}>

                  <Icon
                    id="CardSelectRehabUX-Icon-58"
                    name="print">
                  </Icon>
                  <label
                    id="CardSelectRehabUX-label-59"
                    style={{marginLeft: "6px"}}>
                    {props.languageUX === "en" ? "Print booking" : "พิมพ์การจอง"}
                  </label>
                </Button>
                <div
                  id="CardSelectRehabUX-div-61"
                  style={{marginRight: "0.85rem", display: props.isEditingAppointment?"":"none"}}>
                  {props.buttonConfirmEdit}
                </div>
                <Button
                  color={props.isEditingAppointment?"red":"orange"}
                  id="CardSelectPackageUX-Button-45"
                  onClick={props.onToggleEditAppointment}
                  size="small"
                  style={{marginRight: "0.85rem"}}>
                  {props.isEditingAppointment?"CANCEL EDTING":"EDIT APPOINTMENT"}
                </Button>
                <Button
                  color="red"
                  id="CardSelectPackageUX-Button-46"
                  onClick={props.onCancelAppointment}
                  size="small"
                  style={{display: props.isEditingAppointment?"none":""}}>
                  {props.languageUX === "en" ? "CANCEL APPOINTMENT" : "ยกเลิกการนัดหมาย"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default CardSelectRehabUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Fri Aug 22 2025 11:22:43 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{border: \"1px solid rgba(33, 133, 208, 1)\", minHeight: \"7.5rem\", width: \"100%\", position: \"relative\", borderRadius: \"5px\", ...(props.isNotFound ?{display: \"grid\", placeContent:\"center\"}:{padding:\"0.5rem 1.2rem\"})}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกแผนการรักษา",
          "valueEN": "Select Treatment Plan"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "icon": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-Button-3"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddRehab"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", right: 12, top: 12, fontSize: \"0.9rem\", display: (props.isShowDetail && !props.isEditingAppointment) || !props.isLoadingSuccess? \"none\": \"\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "กรุณาเลือกแผนการรักษาเพื่อทำการนัดหมาย",
          "valueEN": "Please select the treatment plan for scheduling an appointment"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"#BDBDBD\", fontSize: \"1.3rem\", display: props.isNotFound && props.isLoadingSuccess ? \"\":\"none\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rehabItems"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isNotFound || !props.isLoadingSuccess ? \"none\":\"\", margin: \"0.5rem 0\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1.25rem 0.5rem 2rem 1rem\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isShowDetail? \"\": \"none\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormGroup-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "วันและเวลานัดหมาย",
          "valueEN": "Appointment date & time"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#0072BC\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormGroup-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.slotDate || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-label-30"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", fontSize: \"1rem\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormGroup-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "คำแนะนำเพิ่มเติม",
          "valueEN": "Additional advice"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-label-36"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1rem\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormGroup-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormGroup-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"2.5rem 0 2rem\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-Button-44"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintBooking"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isEditingAppointment?\"none\":\"\",marginRight: \"0.85rem\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Button",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.isEditingAppointment?\"CANCEL EDTING\":\"EDIT APPOINTMENT\""
        },
        "color": {
          "type": "code",
          "value": "props.isEditingAppointment?\"red\":\"orange\""
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-Button-45"
        },
        "onClick": {
          "type": "code",
          "value": "props.onToggleEditAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.85rem\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Button",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการนัดหมาย",
          "valueEN": "CANCEL APPOINTMENT"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-Button-46"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelAppointment"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isEditingAppointment?\"none\":\"\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormGroup-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.isPostpone ? \"none\" : \"\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectPackageUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-FormField-50"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 50,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orderNote||\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-div-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-FormGroup-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-FormField-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 56,
      "props": {
        "children": {
          "type": "code",
          "value": "props.physiotherapistName || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Icon",
      "parent": 44,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-Icon-58"
        },
        "name": {
          "type": "value",
          "value": "print"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์การจอง",
          "valueEN": "Print booking"
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-label-59"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "Physiotherapist "
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#0072BC\", fontWeight: \"bold\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirmEdit"
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.85rem\", display: props.isEditingAppointment?\"\":\"none\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-FormGroup-62"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-0.5rem\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-FormField-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "code",
          "value": "props.deviceList"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-div-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Dropdown",
      "parent": 43,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-Dropdown-65"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeLanguage"
        },
        "options": {
          "type": "code",
          "value": "props.languageOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isEditingAppointment?\"none\":\"\", width: \"7rem\",marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.language"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาษา",
          "valueEN": "language"
        },
        "id": {
          "type": "value",
          "value": "CardSelectRehabUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isEditingAppointment?\"none\":\"\",marginRight: \"0.5rem\"}"
        }
      },
      "seq": 44,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardSelectRehabUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
